function fn_layout_main() {
    var reInitGCaptcha;

    reInitGCaptcha = function() {
        $.getScript("https://www.google.com/recaptcha/api.js?render=6LevCSMaAAAAAJe8tjPRbDJ6TXwA_9a6HgD6Z_Z0").done(function () {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LevCSMaAAAAAJe8tjPRbDJ6TXwA_9a6HgD6Z_Z0', {action: 'form'})
                    .then(function (token) {
                        $('#g-token').val(token);
                    });
            });
        });
    };

    if ($('form[data-recaptcha]').length) {
        reInitGCaptcha();
        setInterval(function(){reInitGCaptcha();}, 150000);
    }

    setTimeout(function(){
        fn_scrollreveal();
        $(".twentytwenty-container").twentytwenty();
        $(".comparsion_img").on("mouseenter", function() {
           $(this).addClass("hover");
        });
    }, 300);


    var pull = $('#pull');
    var menu = $('#pull-menu');

    $(pull).on('click', function (e) {
        e.preventDefault();
        menu.stop().slideToggle(500);
        pull.find(".menu-toggle").toggleClass("open");

        return false;
    });

    // var has_submenu = $('.has_submenu');

    // if (has_submenu) {
    //     has_submenu.on("click", function (e) {
    //         e.preventDefault();

    //         has_submenu.parent().toggleClass('active');

    //         return false;
    //     })
    // }

    if($('select').length) {
        $.importStyle(cdnjs.select2_css);
        $.importScript(cdnjs.select2, function (){
            $('select').select2({
                minimumResultsForSearch: -1,
                width: '100%'
            });

            $(".select_open").on("click", function(){
                $('.select2-selection').trigger("click");
            });
        });
    }

    if ($(".part_cookie_consent").length || $(".part_form_cookies").length) {
        $.importScript(cdnjs.cookieconsent);
    }
}
